import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchAircraft from "./searchAircraft";
import SearchManufacturers from "./searchManufacturers";

export default function SearchTabs(props) {
  const [key, setKey] = useState(props.defaultKey);

  const aircraftTitle = (
    <span className="search-tabs">
      <FontAwesomeIcon icon="plane" />
      &nbsp;Aircraft
    </span>
  );
  const brandTitle = (
    <span className="search-tabs">
      <FontAwesomeIcon icon="tools" />
      &nbsp;Brands
    </span>
  );

  return (
    <Tabs id="search-tab" activeKey={key} onSelect={(k) => setKey(k)}>
      <Tab eventKey="aircraft" title={aircraftTitle}>
        <SearchAircraft />
      </Tab>
      <Tab eventKey="manufacturers" title={brandTitle}>
        <SearchManufacturers />
      </Tab>
    </Tabs>
  );
}
